import { render, staticRenderFns } from "./viewProductMapping.vue?vue&type=template&id=994570ea&scoped=true"
import script from "./viewProductMapping.vue?vue&type=script&lang=js"
export * from "./viewProductMapping.vue?vue&type=script&lang=js"
import style0 from "./viewProductMapping.vue?vue&type=style&index=0&id=994570ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994570ea",
  null
  
)

export default component.exports